export const AppIds = {
  BOTSIFY: '1044589648910000',
  SURVEYBOT: '240692566285868',
  FLOW_XO: '1495474070709504',
  JUMPER_AI: '1113963031973049',
  CHATFUEL: '1678638095724206',
  MOBILEMONKEY_INC: '2015199145383303',
  MANYCHAT: '532160876956612',
}

export const AppLabels = {
  [AppIds.BOTSIFY]: 'Botsify',
  [AppIds.SURVEYBOT]: 'Surveybot',
  [AppIds.FLOW_XO]: 'Flow XO',
  [AppIds.JUMPER_AI]: 'jumper.ai',
  [AppIds.CHATFUEL]: 'Chatfuel',
  [AppIds.MOBILEMONKEY_INC]: 'MobileMonkey, Inc.',
  [AppIds.MANYCHAT]: 'Manychat',
}

export enum OptInSources {
  DIRECT = 1,
  ECHO = 2,
  GT = 3,
  MESSENGER = 4,
  IMPORT_SUBSCRIBERS = 5,
  CHANNEL_SMS = 6,
  AUDIENCE = 7,
  WIDGET_KEYWORD = 8,
  API = 10,
  CGT = 12,
  INSTAGRAM = 14,
  PRIVATE_REPLY = 17,
  STORY_MENTION = 18,
  STORY_REPLY_TO = 19,
  TELEGRAM = 20,
  TIKTOK = 23,
  TIKTOK_ADS = 24,
  FOLLOW_REPLY_INSTAGRAM = 25,
}
